import Base64 from "crypto-js/enc-base64";
import Utf8 from "crypto-js/enc-utf8";
import hmacSHA256 from "crypto-js/hmac-sha256";
const base64url = (source) => {
    let encodedSource = Base64.stringify(source);
    encodedSource = encodedSource.replace(/=+$/, "");
    encodedSource = encodedSource.replace(/\+/g, "-");
    encodedSource = encodedSource.replace(/\//g, "_");
    return encodedSource;
};
export function encodeJwt(data, secret = "") {
    const header = {
        typ: "JWT",
        alg: "HS256",
    };
    const stringifiedHeader = Utf8.parse(JSON.stringify(header));
    const encodedHeader = base64url(stringifiedHeader);
    const stringifiedData = Utf8.parse(JSON.stringify(data));
    const encodedData = base64url(stringifiedData);
    const token = `${encodedHeader}.${encodedData}`;
    const signature = base64url(hmacSHA256(token, secret));
    return `${token}.${signature}`;
}
export function decodeJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64)
        .split("")
        .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(""));
    return JSON.parse(jsonPayload);
}
//# sourceMappingURL=jwt.js.map